<template>
  <el-dialog 
    title="新增设备" 
    :visible.sync="dialogVisible" 
    width="600px" 
    @close="resetForm" 
    :close-on-click-modal="false"
  >
    <div class="form-container">
      <el-form :model="createForm" :rules="rules" ref="createForm" label-width="140px" size="small">
        <el-form-item label="设备IP：" prop="host_ip">
          <el-input v-model="createForm.host_ip" placeholder="请输入设备IP"></el-input>
        </el-form-item>
        <el-form-item label="设备名称：" prop="hostname">
          <el-input v-model="createForm.hostname" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="IPMI地址：" prop="ipmi_addr">
          <el-input v-model="createForm.ipmi_addr" placeholder="请输入IPMI地址"></el-input>
        </el-form-item>
        <el-form-item label="IPMI用户：" prop="ipmi_user">
          <el-input v-model="createForm.ipmi_user" placeholder="请输入IPMI用户"></el-input>
        </el-form-item>
        <el-form-item label="设备类型：" prop="dev_type">
          <el-select v-model="createForm.dev_type" placeholder="请选择设备类型" style="width: 100%;">
            <el-option
              v-for="(item, index) in devTypeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源类型：" prop="dev_character">
          <el-select 
            v-model="createForm.dev_character" 
            placeholder="请选择资源类型" 
            style="width: 100%;"
          >
            <el-option 
              v-for="item in devCharacter" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="提供商：" prop="provider_id">
          <el-select 
            v-model="createForm.provider_id" 
            placeholder="请选择提供商" 
            style="width: 100%;" 
            :loading="loading"
            @change="handleProviderChange"
          >
            <el-option 
              v-for="item in options" 
              :key="item.provider_id" 
              :label="item.provider" 
              :value="item.provider_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="可用区：" prop="az_id"> 
          <el-select 
            v-model="createForm.az_id" 
            placeholder="请选择可用区" 
            style="width: 100%;" 
            :loading="azloading"
            :disabled="!createForm.provider_id"
          >
            <el-option 
              v-for="item in azoptions" 
              :key="item.az_id" 
              :label="item.az_name" 
              :value="item.az_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="算力规格：" prop="products_id">
          <el-select 
            v-model="createForm.products_id" 
            placeholder="请选择算力规格" 
            style="width: 100%;" 
            :loading="productsLoading"
          >
            <el-option 
              v-for="item in productsOptions" 
              :key="item.id" 
              :label="item.title" 
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="可用期开始时间：" prop="start_time">
          <el-date-picker
            v-model="createForm.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="可用期结束时间：" prop="end_time">
          <el-date-picker
            v-model="createForm.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="状态：" prop="status">
        <el-select v-model="createForm.status" placeholder="请选择状态" style="width: 100%;">
          <el-option label="有效" :value="0"></el-option>
          <el-option label="无效" :value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="使用状态：" prop="active_state"> 
        <el-select v-model="createForm.active_state" placeholder="请选择状态" style="width: 100%;">
          <el-option label="空闲" :value="0"></el-option>
          <el-option label="占用" :value="1"></el-option>
          <el-option label="维护中" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="运行状态：" prop="running_state">
        <el-select v-model="createForm.running_state" placeholder="请选择运行状态" style="width: 100%;">
          <el-option label="在线" :value="0"></el-option>
          <el-option label="离线" :value="1"></el-option>
        </el-select>
      </el-form-item>

        <el-form-item label="设备规格型号：" prop="ext_06">
          <el-select
            v-model="createForm.ext_06"
            placeholder="请选择设备规格型号"
            style="width: 100%"
            :loading="resourceTypeLoading"
          >
            <el-option
              v-for="item in resourceTypeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" :rows="3" v-model="createForm.remark" placeholder="请输入备注（可选）"></el-input>
        </el-form-item>

        <el-form-item label="规格描述：" prop="spec_desc">
          <el-input type="textarea" :rows="3" v-model="createForm.spec_desc" placeholder="请输入备注（可选）"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateDeviceDialog',
  props: {
    isNonManaged: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateIP = (rule, value, callback) => {
      const ipPattern = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
      if (!value) {
        return callback(new Error('请输入IP地址'));
      }
      if (!ipPattern.test(value)) {
        return callback(new Error('IP地址格式不正确'));
      }
      const parts = value.split('.');
      for (let i = 0; i < parts.length; i++) {
        const part = parseInt(parts[i], 10);
        if (part < 0 || part > 255) {
          return callback(new Error('IP地址段必须在 0-255 之间'));
        }
        if (parts[i].length > 1 && parts[i].startsWith('0')) {
          return callback(new Error('IP地址段不能包含前导零'));
        }
      }
      callback();
    };

    return {
      dialogVisible: false,
      loading: true,
      options: [],     // 提供商列表
      azloading: false, // 可用区是否加载中
      azoptions: [],   // 当前可用区列表（按 provider 过滤）
      productsLoading: false,
      productsOptions: [],   // 算力规格列表
      resourceTypeLoading: false,
      resourceTypeOptions: [],
      devCharacter: [
        { label: 'GPU节点 - 台·日', value: 'GPU节点' },
        { label: 'CPU节点 - 台·月', value: 'CPU节点' },
        { label: '存储 - T·月', value: '存储' },
        { label: '容器云 - 卡·时', value: '容器云' },
        { label: '其他 - 台·月', value: '其他' }
      ],
      createForm: {
        host_ip: '',
        hostname: '',
        ipmi_addr: '',
        ipmi_user: '',
        dev_type: '0',
        dev_character: '',
        provider_id: '',
        provider: '',
        az_id: '',
        az_name: '',
        start_time: '',
        end_time: '',
        status: 0,
        active_state: 0,
        running_state: 0,
        remark: '',
        spec_desc: '',
        ext_05: 0,
        ext_06: '',
        products_id: ''
      },
      rules: {
        host_ip: [
          { required: true, message: '请输入设备IP', trigger: 'blur' },
          { validator: validateIP, trigger: 'blur' }
        ],
        hostname: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        ipmi_addr: [
          { required: true, message: '请输入IPMI地址', trigger: 'blur' },
          { validator: validateIP, trigger: 'blur' }
        ],
        ipmi_user: [
          { required: true, message: '请输入IPMI用户', trigger: 'blur' }
        ],
        dev_character: [
          { required: true, message: '请选择资源类型', trigger: 'change' }
        ],
        provider_id: [
          { required: true, message: '请选择提供商', trigger: 'change' }
        ],
        az_id: [
          { required: true, message: '请选择可用区', trigger: 'change' }
        ],
        products_id: [
          { required: true, message: '请选择算力规格', trigger: 'change' }
        ],
        start_time: [
          {
            validator: (rule, value, callback) => {
              callback(); // 非必填
            },
            trigger: 'change'
          }
        ],
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.createForm.start_time;
              const endTime = value;

              if (!startTime || !endTime) {
                return callback();
              }

              const start = new Date(startTime);
              const end = new Date(endTime);

              if (end <= start) {
                callback(new Error('结束时间必须大于开始时间'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      },
      devTypeOptions: [
        { label: '服务器', value: '0'  },
        { label: '虚拟机', value: '1' },
        { label: '容器', value: '2' },
        { label: '交换机', value: '3' },
        { label: '防火墙', value: '4' },
        { label: '路由器', value: '5' },
        { label: '动环系统' , value: '6'},
        { label: '录像机或摄像头' , value: '7'},
        { label: '传感器', value: '8' }
      ]
    };
  },
  methods: {
    openDialog() {
      this.fetchProviders();
      this.fetchProducts();
      this.fetchResourceTypes();
      this.createForm.ext_05 = this.isNonManaged ? 1 : 0;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.createForm.clearValidate();
      });
    },

    fetchProducts() {
      this.productsLoading = true;
      this.$axios.get('/api-30216/api/compute-products', {
        params: {
          page: 1,
          pageSize: 100
        }
      })
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.productsOptions = res.data.map(item => ({
              id: item.id,
              title: item.title
            }));
          } else {
            this.$message.error(res.message || '加载算力规格失败');
            this.productsOptions = [];
          }
        })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.productsOptions = [];
        })
        .finally(() => {
          this.productsLoading = false;
        });
    },

    /**
     * 获取资源类型列表
     */
    fetchResourceTypes() {
      this.resourceTypeLoading = true;
      this.$axios.get('/api-30216/api/compute-types')
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.resourceTypeOptions = res.data.map(item => ({
              id: item.id,
              name: item.name
            }));
          } else {
            this.$message.warning('获取资源类型失败');
            this.resourceTypeOptions = [];
          }
        })
        .catch(() => {
          this.$message.error('网络错误，无法获取资源类型');
          this.resourceTypeOptions = [];
        })
        .finally(() => {
          this.resourceTypeLoading = false;
        });
    },

    resetForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields();
      }
      // 清空关联字段
      this.createForm.provider = '';
      this.createForm.az_name = '';
      this.azoptions = [];
      this.resourceTypeOptions = [];
    },

    handleProviderChange(providerId) {
  const selected = this.options.find(item => item.provider_id === providerId);
  if (selected) {
    this.createForm.provider = selected.provider; // 保存名字
    this.fetchAzname(selected.provider);         // ✅ 把 provider 名字传进去
  } else {
    this.createForm.provider = '';
    this.fetchAzname(''); // 或清空
  }

  // 清空之前选择的可用区
  this.createForm.az_id = '';
  this.createForm.az_name = '';
  this.azoptions = [];
},

    fetchProviders() {
      this.loading = true;
      this.$axios.get('/api-30216/api/regions')
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.options = res.data.map(item => ({
              provider_id: item.id,
              provider: item.provider || '未知提供商'
            }));
          } else {
            this.$message.error(res.message || '加载提供商失败');
            this.options = [];
          }
        })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.options = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchAzname(providerName) {
  this.azloading = true;
  
  if (!providerName) {
    this.azoptions = [];
    this.azloading = false;
    return Promise.resolve();
  }

  // ✅ 改为使用 ?provider=xxx
  const url = `/api-30216/api/zones?provider=${encodeURIComponent(providerName)}`;

  return this.$axios.get(url)
    .then(res => {
      if (res.code === 200 && Array.isArray(res.data)) {
        this.azoptions = res.data.map(item => ({
          az_id: item.id,
          az_name: item.name || '未知可用区'
        }));
      } else {
        this.$message.warning(res.message || '该提供商下暂无可用区');
        this.azoptions = [];
      }
    })
    .catch(err => {
      this.$message.error('获取可用区失败，请检查网络或联系管理员');
      console.error(err);
      this.azoptions = [];
    })
    .finally(() => {
      this.azloading = false;
    });
},

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return;

        // 提交前自动填充 az_name
        const selectedAz = this.azoptions.find(az => az.az_id === this.createForm.az_id);
        if (selectedAz) {
          this.createForm.az_name = selectedAz.az_name;
        }

        const postData = { ...this.createForm };

        this.$axios.post('/api-30216/api/devices', postData)
          .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200) {
              this.$message.success(responseData.message || '新增成功');
              this.dialogVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(responseData.message || '新增失败');
            }
          })
          .catch(err => {
            let errorMessage = '请求失败';
            if (err && err.response && err.response.data && err.response.data.message) {
              errorMessage = err.response.data.message;
            } else if (err && err.message) {
              errorMessage = err.message;
            }
            this.$message.error(errorMessage);
            console.error('提交错误详情:', err);
          });
      });
    }
  }
};
</script>

<style scoped>
.form-container {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}
.form-container::-webkit-scrollbar {
  width: 6px;
}
.form-container::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
.dialog-footer {
  text-align: right;
}
</style>